module.exports = __webpack_public_path__ + "img/Deathknight-tauren-f-70.91fcbff6.gif";